const Getters = {
    get_makes: 'getMakes',
    get_bodies: 'getBodies',
    get_colors: 'getColors',
    get_conditions: 'getConditions',
    get_transmissions: 'getTransmissions',
    get_fuel_types: 'getFuelTypes',
    get_number_of_doors: 'getNumberOfDoors',
    get_drives: 'getDrives',
    get_holding_periods: 'getHoldingPeriods',
    get_distances_from_me: 'getDistancesFromMe',
    get_price_ranges: 'getPriceRanges',
};

export default Getters
